import FileUploadStatus from './FileUploadStatus';
import './FileUploadStatus.scss';

export default FileUploadStatus;
